export default "/048cb1f2b29308e18768c65cfd51e426596a830c/78489dd5fe22b2b724f99f5861a7cee7.svg";